var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobilePlayStore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 282,
    height: 73,
    viewBox: "0 0 282 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 281.05,
    height: 73,
    rx: 36.5,
    fill: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M140.823 39.6952C136.53 39.6952 133.032 42.9601 133.032 47.4569C133.032 51.9263 136.53 55.2186 140.823 55.2186C145.117 55.2186 148.615 51.9263 148.615 47.4569C148.613 42.9601 145.115 39.6952 140.823 39.6952ZM140.823 52.1636C138.47 52.1636 136.443 50.2236 136.443 47.4587C136.443 44.6646 138.472 42.7538 140.823 42.7538C143.175 42.7538 145.203 44.6646 145.203 47.4587C145.203 50.2218 143.175 52.1636 140.823 52.1636ZM123.824 39.6952C119.532 39.6952 116.034 42.9601 116.034 47.4569C116.034 51.9263 119.532 55.2186 123.824 55.2186C128.119 55.2186 131.617 51.9263 131.617 47.4569C131.617 42.9601 128.119 39.6952 123.824 39.6952ZM123.824 52.1636C121.472 52.1636 119.444 50.2236 119.444 47.4587C119.444 44.6646 121.474 42.7538 123.824 42.7538C126.177 42.7538 128.204 44.6646 128.204 47.4587C128.206 50.2218 126.177 52.1636 123.824 52.1636ZM103.607 42.0786V45.3709H111.487C111.252 47.2233 110.635 48.5756 109.693 49.5155C108.547 50.6616 106.753 51.9263 103.607 51.9263C98.7563 51.9263 94.9639 48.0153 94.9639 43.1645C94.9639 38.3136 98.7563 34.4027 103.607 34.4027C106.224 34.4027 108.135 35.432 109.546 36.7551L111.869 34.4319C109.898 32.5503 107.283 31.1104 103.607 31.1104C96.9623 31.1104 91.376 36.5197 91.376 43.1645C91.376 49.8093 96.9623 55.2186 103.607 55.2186C107.193 55.2186 109.9 54.0415 112.015 51.8369C114.19 49.6615 114.867 46.6028 114.867 44.1335C114.867 43.3707 114.809 42.6644 114.69 42.0768H103.607V42.0786ZM186.294 44.6354C185.648 42.9017 183.677 39.6952 179.649 39.6952C175.651 39.6952 172.328 42.8415 172.328 47.4569C172.328 51.8077 175.622 55.2186 180.031 55.2186C183.588 55.2186 185.646 53.0432 186.5 51.7785L183.854 50.0137C182.973 51.3076 181.766 52.1599 180.031 52.1599C178.297 52.1599 177.062 51.366 176.268 49.8075L186.646 45.5151L186.294 44.6354ZM175.709 47.2233C175.622 44.223 178.032 42.6955 179.768 42.6955C181.12 42.6955 182.266 43.3725 182.65 44.3416L175.709 47.2233ZM167.272 54.7496H170.681V31.9353H167.272V54.7496ZM161.684 41.4307H161.567C160.803 40.5182 159.332 39.6952 157.481 39.6952C153.599 39.6952 150.042 43.1061 150.042 47.4879C150.042 51.8387 153.599 55.2204 157.481 55.2204C159.334 55.2204 160.803 54.3974 161.567 53.4575H161.684V54.5744C161.684 57.5437 160.096 59.1314 157.54 59.1314C155.452 59.1314 154.158 57.6331 153.629 56.3684L150.659 57.6039C151.512 59.6607 153.775 62.1901 157.54 62.1901C161.538 62.1901 164.92 59.8377 164.92 54.1035V40.1678H161.686V41.4307H161.684ZM157.775 52.1636C155.423 52.1636 153.453 50.1926 153.453 47.4879C153.453 44.7522 155.423 42.7538 157.775 42.7538C160.096 42.7538 161.92 44.7522 161.92 47.4879C161.92 50.1926 160.096 52.1636 157.775 52.1636ZM202.27 31.9353H194.111V54.7496H197.514V46.1064H202.268C206.043 46.1064 209.755 43.3744 209.755 39.0217C209.755 34.6691 206.044 31.9353 202.27 31.9353ZM202.358 42.9309H197.514V35.1108H202.358C204.904 35.1108 206.349 37.2186 206.349 39.0217C206.349 40.7883 204.904 42.9309 202.358 42.9309ZM223.404 39.655C220.938 39.655 218.385 40.7409 217.328 43.1481L220.351 44.4091C220.997 43.1481 222.201 42.7356 223.462 42.7356C225.223 42.7356 227.014 43.7923 227.043 45.6702V45.9056C226.426 45.5534 225.105 45.026 223.491 45.026C220.234 45.026 216.916 46.8163 216.916 50.1615C216.916 53.2148 219.588 55.1803 222.581 55.1803C224.869 55.1803 226.132 54.1528 226.924 52.9483H227.041V54.7094H230.33V45.9622C230.331 41.9144 227.306 39.655 223.404 39.655ZM222.991 52.1581C221.878 52.1581 220.321 51.5996 220.321 50.2199C220.321 48.4588 222.26 47.7835 223.933 47.7835C225.428 47.7835 226.134 48.1066 227.043 48.5464C226.778 50.6616 224.959 52.1581 222.991 52.1581ZM242.305 40.1532L238.402 50.0447H238.285L234.233 40.1532H230.565L236.641 53.9776L233.177 61.6682H236.728L246.092 40.1532H242.305ZM211.634 54.7496H215.038V31.9353H211.634V54.7496Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M103.012 18.6936C103.012 20.2229 102.56 21.4402 101.653 22.349C100.623 23.4294 99.2802 23.9696 97.6304 23.9696C96.05 23.9696 94.7049 23.4221 93.6008 22.3271C92.4949 21.2303 91.9419 19.8725 91.9419 18.2519C91.9419 16.6295 92.4949 15.2717 93.6008 14.1767C94.7049 13.0799 96.05 12.5324 97.6304 12.5324C98.4152 12.5324 99.1652 12.6857 99.877 12.9904C100.591 13.297 101.162 13.704 101.589 14.2132L100.627 15.1768C99.9025 14.3099 98.9043 13.8774 97.6286 13.8774C96.4752 13.8774 95.4787 14.2825 94.6374 15.0928C93.7961 15.9031 93.3763 16.9562 93.3763 18.2501C93.3763 19.544 93.7961 20.597 94.6374 21.4073C95.4787 22.2176 96.4752 22.6228 97.6286 22.6228C98.8513 22.6228 99.8715 22.2158 100.687 21.4C101.217 20.869 101.523 20.1298 101.605 19.1827H97.6286V17.8668H102.934C102.989 18.1534 103.012 18.4289 103.012 18.6936Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M111.426 14.1202H106.44V17.5914H110.937V18.9072H106.44V22.3783H111.426V23.7252H105.033V12.7752H111.426V14.1202Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M117.359 23.7252H115.952V14.1202H112.893V12.7752H120.417V14.1202H117.359V23.7252Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M125.861 23.7252V12.7752H127.268V23.7252H125.861Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M133.508 23.7252H132.101V14.1202H129.042V12.7752H136.567V14.1202H133.508V23.7252Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M150.811 22.3108C149.734 23.4168 148.396 23.9697 146.796 23.9697C145.195 23.9697 143.857 23.4168 142.783 22.3108C141.706 21.2049 141.169 19.8507 141.169 18.2502C141.169 16.6497 141.706 15.2955 142.783 14.1896C143.857 13.0836 145.195 12.5288 146.796 12.5288C148.387 12.5288 149.723 13.0854 150.803 14.1969C151.884 15.3083 152.424 16.6588 152.424 18.2502C152.424 19.8507 151.886 21.2049 150.811 22.3108ZM143.821 21.3928C144.631 22.2141 145.622 22.6229 146.796 22.6229C147.969 22.6229 148.962 22.2123 149.77 21.3928C150.581 20.5716 150.988 19.524 150.988 18.2502C150.988 16.9763 150.581 15.9288 149.77 15.1075C148.962 14.2863 147.969 13.8775 146.796 13.8775C145.622 13.8775 144.631 14.2881 143.821 15.1075C143.012 15.9288 142.605 16.9763 142.605 18.2502C142.605 19.524 143.012 20.5716 143.821 21.3928Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M154.399 23.7252V12.7752H156.111L161.432 21.2925H161.492L161.432 19.1828V12.7752H162.839V23.7252H161.37L155.802 14.7937H155.742L155.802 16.9034V23.7252H154.399Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M103.012 18.6936C103.012 20.2229 102.56 21.4402 101.653 22.349C100.623 23.4294 99.2802 23.9696 97.6304 23.9696C96.05 23.9696 94.7049 23.4221 93.6008 22.3271C92.4949 21.2303 91.9419 19.8725 91.9419 18.2519C91.9419 16.6295 92.4949 15.2717 93.6008 14.1767C94.7049 13.0799 96.05 12.5324 97.6304 12.5324C98.4152 12.5324 99.1652 12.6857 99.877 12.9904C100.591 13.297 101.162 13.704 101.589 14.2132L100.627 15.1768C99.9025 14.3099 98.9043 13.8774 97.6286 13.8774C96.4752 13.8774 95.4787 14.2825 94.6374 15.0928C93.7961 15.9031 93.3763 16.9562 93.3763 18.2501C93.3763 19.544 93.7961 20.597 94.6374 21.4073C95.4787 22.2176 96.4752 22.6228 97.6286 22.6228C98.8513 22.6228 99.8715 22.2158 100.687 21.4C101.217 20.869 101.523 20.1298 101.605 19.1827H97.6286V17.8668H102.934C102.989 18.1534 103.012 18.4289 103.012 18.6936Z",
    stroke: "white",
    strokeWidth: 0.365,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M111.426 14.1202H106.44V17.5914H110.937V18.9072H106.44V22.3783H111.426V23.7252H105.033V12.7752H111.426V14.1202Z",
    stroke: "white",
    strokeWidth: 0.365,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M117.359 23.7252H115.952V14.1202H112.893V12.7752H120.417V14.1202H117.359V23.7252Z",
    stroke: "white",
    strokeWidth: 0.365,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M125.861 23.7252V12.7752H127.268V23.7252H125.861Z",
    stroke: "white",
    strokeWidth: 0.365,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M133.508 23.7252H132.101V14.1202H129.042V12.7752H136.567V14.1202H133.508V23.7252Z",
    stroke: "white",
    strokeWidth: 0.365,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M150.811 22.3108C149.734 23.4168 148.396 23.9697 146.796 23.9697C145.195 23.9697 143.857 23.4168 142.783 22.3108C141.706 21.2049 141.169 19.8507 141.169 18.2502C141.169 16.6497 141.706 15.2955 142.783 14.1896C143.857 13.0836 145.195 12.5288 146.796 12.5288C148.387 12.5288 149.723 13.0854 150.803 14.1969C151.884 15.3083 152.424 16.6588 152.424 18.2502C152.424 19.8507 151.886 21.2049 150.811 22.3108ZM143.821 21.3928C144.631 22.2141 145.622 22.6229 146.796 22.6229C147.969 22.6229 148.962 22.2123 149.77 21.3928C150.581 20.5716 150.988 19.524 150.988 18.2502C150.988 16.9763 150.581 15.9288 149.77 15.1075C148.962 14.2863 147.969 13.8775 146.796 13.8775C145.622 13.8775 144.631 14.2881 143.821 15.1075C143.012 15.9288 142.605 16.9763 142.605 18.2502C142.605 19.524 143.012 20.5716 143.821 21.3928Z",
    stroke: "white",
    strokeWidth: 0.365,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M154.399 23.7252V12.7752H156.111L161.432 21.2925H161.492L161.432 19.1828V12.7752H162.839V23.7252H161.37L155.802 14.7937H155.742L155.802 16.9034V23.7252H154.399Z",
    stroke: "white",
    strokeWidth: 0.365,
    strokeMiterlimit: 10
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ii_14446_152334)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.5198 13.7568C34.9887 14.3189 34.6748 15.1912 34.6748 16.3209V56.6826C34.6748 57.8141 34.9887 58.6846 35.5198 59.2467L35.6548 59.3781L58.2648 36.7682V36.5017V36.2353L35.6548 13.6235L35.5198 13.7568Z",
    fill: "url(#paint0_linear_14446_152334)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.8001 44.307L58.2646 36.7679V36.5015V36.235L65.8019 28.6978L65.9716 28.7945L74.9013 33.868C77.4509 35.317 77.4509 37.6877 74.9013 39.1386L65.9716 44.2121L65.8001 44.307Z",
    fill: "url(#paint1_linear_14446_152334)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_14446_152334)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65.9715 44.2103L58.2627 36.5015L35.5195 59.2464C36.359 60.137 37.7479 60.2465 39.3119 59.3596L65.9715 44.2103Z",
    fill: "url(#paint2_linear_14446_152334)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M65.9715 28.7931L39.3119 13.6456C37.7479 12.7568 36.359 12.8681 35.5195 13.7587L58.2645 36.5037L65.9715 28.7931Z",
    fill: "url(#paint3_linear_14446_152334)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ii_14446_152334",
    x: 34.6748,
    y: 13.0322,
    width: 42.1387,
    height: 46.9399,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.27375
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_14446_152334"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.27375
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_14446_152334",
    result: "effect2_innerShadow_14446_152334"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_14446_152334",
    x: 35.5195,
    y: 36.5015,
    width: 30.4521,
    height: 23.4707,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.27375
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_14446_152334"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_14446_152334",
    x1: 56.2605,
    y1: 15.8938,
    x2: 25.6334,
    y2: 46.521,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0066,
    stopColor: "#00A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2601,
    stopColor: "#00BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5122,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7604,
    stopColor: "#00DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_14446_152334",
    x1: 78.2201,
    y1: 36.5015,
    x2: 34.0626,
    y2: 36.5015,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4087,
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    stopColor: "#FFA500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_14446_152334",
    x1: 61.7851,
    y1: 40.6878,
    x2: 20.2509,
    y2: 82.2221,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_14446_152334",
    x1: 29.7916,
    y1: 0.3227,
    x2: 48.3378,
    y2: 18.8689,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0685,
    stopColor: "#2DA771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4762,
    stopColor: "#15CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8009,
    stopColor: "#06E775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F076"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobilePlayStore);
export default __webpack_public_path__ + "static/media/Mobile_play_store.0f1b902f64368e534ff65ef4ceba4416.svg";
export { ForwardRef as ReactComponent };